import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id',
  'name',
  'font_size',
  'created_at', 
  'updated_at',
  { file: ['id', 'representations', 'filename', 'url'] },
  { pages: ['id', 'number', 'height'] },
  { elements: ['id', 'elementable', 'elementable_type', 'x', 'y', 'width', 'height', { page: ['id', 'number'] }] }
] ;

export const getTemplate = asyncThunkWrapper({ 
  model: 'templates', 
  action: 'getTemplate', 
  func: async (id) => {
    const params = { attributes };
    const response = await axios.get(`/templates/${id}`, { params });

    return response.data;
  } 
});
export const updateTemplate = asyncThunkWrapper({ 
  model: 'templates', 
  action: 'updateTemplate', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/templates/${id}`, { template: { id, ...fields } });

    return { status: response.status, template: { ...fields } };
  } 
});
export const deleteTemplate = asyncThunkWrapper({ 
  model: 'templates', 
  action: 'deleteTemplate', 
  func: async (id) => {
    const response = await axios.delete(`/templates/${id}`);

    return { status: response.status, id };
  } 
});